import React from 'react';
import { PropertyGroup } from './PropertyGroup';

/**
 * Default value property for switch fields
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SwitchDefaultProperty = _ref => {
  let {
    field,
    updateField,
    selectedField
  } = _ref;
  if (field.type !== 'switch') {
    return null;
  }
  return /*#__PURE__*/_jsx(PropertyGroup, {
    children: /*#__PURE__*/_jsxs("label", {
      className: "checkbox-label",
      children: [/*#__PURE__*/_jsx("input", {
        type: "checkbox",
        checked: field.defaultValue === true || field.defaultValue === 'true',
        onChange: e => updateField(selectedField, {
          defaultValue: e.target.checked
        })
      }), "Default to checked"]
    })
  });
};